import { Autocomplete, MenuItem } from "@mui/material";

import classNames from "classnames";
import CustomInput from "../CustomInput2";

const NewMultiSearchAndSelect = ({
  options,
  label,
  setValue,
  placeholder,
  className,
  inputClassName,
  loading,
  formik,
  name,
  setSearchValue,
}) => {
  const handleChange = (_, val) => {
    if (formik) {
      formik.setFieldValue(name, val);
    } else {
      setValue(val);
    }
  };

  return (
    <Autocomplete
      multiple
      options={options}
      loading={loading}
      value={formik ? formik.values[name] || [] : []}
      onChange={handleChange}
      className={className}
      getOptionLabel={(option) => option.label || ""}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onInputChange={(_, val) => setSearchValue(val)}
      renderInput={(params) => (
        <CustomInput
          {...params}
          className={classNames(inputClassName, "!p-2 multi-search-and-select")}
          variant="standard"
          label={label}
          placeholder={placeholder}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <MenuItem
          {...props}
          key={option.value}
          className={selected ? "!bg-gray-200 !my-1" : ""}
          sx={{ justifyContent: "space-between" }}
        >
          {option.label}
        </MenuItem>
      )}
    />
  );
};

export default NewMultiSearchAndSelect;
